import { userNamespace } from "@/store/modules/user";
import { Component, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";

@Component({
  components: {}
})
export default class CopyRightFooter extends Vue {
  @Getter("areas", userNamespace)
  areas!: Array<string>;

  @Getter("system", userNamespace)
  systemInfo!: Record<string, any>;

  get currentYear() {
    return new Date().getFullYear();
  }

  get versionDisplay() {
    if (this.systemInfo.version == null || this.systemInfo.version === "")
      return "";
    else if (!this.isMobileThin)
      return this.systemInfo.version + " rev " + this.systemInfo.siteRev;
    else {
      return this.systemInfo.version.replace("Alpha", "a").replace("Beta", "b");
    }
  }

  get systemName() {
    return this.systemInfo.system == null || this.systemInfo.system === ""
      ? ""
      : this.systemInfo.system.replace("AW.", "").replace(".", " ");
  }

  get isMobileThin() {
    return (
      this.$vuetify.breakpoint.smAndDown && this.$vuetify.breakpoint.width < 510
    );
  }
  get fontSize() {
    return this.isMobileThin ? "caption" : "body-1";
  }
}
